import { useState, useCallback } from "react";
import { usePrayer } from "../context/PrayerContext";
import prayersData from "../data/prayers_collection.json";

export const usePrayerSelector = () => {
  const { setSelectedPrayer } = usePrayer();
  const [isSelecting, setIsSelecting] = useState(false);

  const selectRandomPrayer = useCallback(() => {
    setIsSelecting(true);

    // 랜덤 선택 로직
    const prayers = prayersData.prayers;
    const randomIndex = Math.floor(Math.random() * prayers.length);
    const selectedPrayer = prayers[randomIndex];

    // 약간의 지연을 주어 로딩 느낌 연출
    setTimeout(() => {
      setSelectedPrayer(selectedPrayer);
      setIsSelecting(false);
    }, 500);

    return selectedPrayer;
  }, [setSelectedPrayer]);

  const selectPrayerById = useCallback(
    (id) => {
      const prayers = prayersData.prayers;
      const selectedPrayer = prayers.find((prayer) => prayer.id === id);

      if (selectedPrayer) {
        setSelectedPrayer(selectedPrayer);
      }

      return selectedPrayer;
    },
    [setSelectedPrayer]
  );

  return {
    selectRandomPrayer,
    selectPrayerById,
    isSelecting,
  };
};
